/* __next_internal_client_entry_do_not_use__ SafelySetInnerHTML auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { sanitize } from "isomorphic-dompurify";
import React from "react";
/**
 * Use in place of dangerouslySetInnerHTML to sanitize html before setting it
 */ export var SafelySetInnerHTML = function(param) {
    var html = param.html, tag = param.tag, _param_isWholeDocument = param.isWholeDocument, isWholeDocument = _param_isWholeDocument === void 0 ? false : _param_isWholeDocument, _param_keepTargetAttribute = param.keepTargetAttribute, keepTargetAttribute = _param_keepTargetAttribute === void 0 ? false : _param_keepTargetAttribute;
    if (!html) {
        return null;
    }
    var attributesWhiteList = keepTargetAttribute ? [
        "target"
    ] : [];
    var sanitizeConfig = {
        WHOLE_DOCUMENT: isWholeDocument,
        ADD_ATTR: attributesWhiteList
    };
    var Tag = tag !== null && tag !== void 0 ? tag : "div";
    var sanitizedHtml = sanitize(html, sanitizeConfig);
    return /*#__PURE__*/ _jsx(Tag, {
        dangerouslySetInnerHTML: {
            __html: sanitizedHtml
        }
    });
};
